import React from 'react';

export default function JustinQuote() {
  return (
    <section className="relative py-10 md:py-14 border-t border-white/10 overflow-hidden bg-[#111111]">
      <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent pointer-events-none" />
      <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 text-center">
        <div className="w-16 h-px bg-[#C97B2E] mx-auto mb-6" />
        <blockquote className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight italic mb-5">
          "Quality Work Starts with Quality Preparation."
        </blockquote>
        <div className="flex items-center justify-center gap-4">
          <div className="w-8 h-px bg-white/20" />
          <p className="font-body text-white/50 text-xs uppercase tracking-[0.3em] font-bold">
            Justin — Founder, Terza Costa Construction
          </p>
          <div className="w-8 h-px bg-white/20" />
        </div>
      </div>
    </section>
  );
}